import {ffiClient} from "./";
import qs from "querystring";
import _ from "lodash";
import encrypt from "./encrypt";

export const _getUserKey = () => {
  return ffiClient.get(`/user_key/get`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getConnectionRecord = (params) => {
  return ffiClient
    .get(`/connection_record/get`, {
      params
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getApiRecord = (params) => {
  return ffiClient
    .get(`/api_record/get`, {
      params
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _getApiCount = (params) => {
  return ffiClient.get(`/api_count/get`, {
    params
  }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _addNewUserKey = (params) => {
  return ffiClient.get(`/user_key/add`, {
    params
  }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getAvailableKey = (params) => {
  return ffiClient.get(`/user_key/available`, {
    params
  }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _deleteUserKey = (userKey) => {
  return ffiClient.post(`/user_key/delete?user_key=${userKey}`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getActivedUser = () => {
  return ffiClient.get(`/active_user/get`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(new Error(`${res.error_msg}`));
    }
  });
};
